import { createModule } from 'saga-slice';
import { getUniqueKey } from '../../utils/utils';
import { initialState, NotificationState } from './stateType';

const Slice = createModule({
  name: 'notifications',
  initialState,
  reducers: {
    enqueueSuccessSnackbar: (state: NotificationState, payload: string) => {
      state.notifications.push({
        msg: payload,
        key: getUniqueKey(),
        options: { variant: 'success' },
      });
    },
    enqueueErrorSnackbar: (state: NotificationState, payload: string) => {
      state.notifications.push({
        msg: payload ? payload : 'Sorry, something went wrong',
        key: getUniqueKey(),
        options: { variant: 'error' },
      });
    },
    enqueueWarningSnackbar: (state: NotificationState, payload: string) => {
      state.notifications.push({
        msg: payload,
        key: getUniqueKey(),
        options: { variant: 'warning' },
      });
    },
    enqueueInfoSnackbar: (state: NotificationState, payload: string) => {
      state.notifications.push({
        msg: payload,
        key: getUniqueKey(),
        options: { variant: 'info' },
      });
    },
    removeSnackbar: (state: NotificationState, payload) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.key !== payload,
      );
    },
  },
});

export default Slice;
export const notificationsActions = Slice.actions;
